import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
	createBlackBoardInfo,
	editBlackBoardInfo,
	getBlackBoardList,
} from '../../../API/repositories/blackboardInfo';
import { formatDate } from '../../../common/functions/dateFormater';
import { useRequestsContext } from '../../../common/hooks/requestHook';
import { CONSULTANT_ROLES } from '../../login/components/LoginForm/loginForm';
import BlackboardAction from './BlackboardAction';
import Loading from '../../../common/components/Loading';
import { useCommonDataContext } from '../../../common/hooks/commonDataContext';
import ActionButton from '@/common/components/buttons/ActionButton';
import Icon from '@/common/components/Icon';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	margin: 30px;
	gap: 50px;
`;

export const MODE = {
	EDIT: 'Edit',
	CREATE: 'Create',
};

const BlackboardList = () => {
	const [mode, setMode] = useState(null);
	const [edit, setEdit] = useState(false);
	const [usersOptions, setUsersOptions] = useState();

	const [data, setData] = useState();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { filterUsersByRoles, commonData } = useCommonDataContext();
	const { users } = commonData;

	const handleLoadData = async (e) => {
		e && e.preventDefault();

		setUsersOptions(filterUsersByRoles(CONSULTANT_ROLES), 'username', '_id');

		const dataResponse = await makeRequest(getBlackBoardList);

		if (dataResponse.data) {
			setData(() => dataResponse.data);
		}
	};

	useEffect(() => {
		handleLoadData();
	}, [edit, users]);

	return (
		<Wrapper>
			{(hasUnfilledRequest(createBlackBoardInfo) ||
				hasUnfilledRequest(editBlackBoardInfo)) && <Loading />}
			<div style={{ width: '100%', textAlign: 'left' }}>
				<ActionButton
					onClick={() => {
						setMode(() => MODE.CREATE);
					}}
					defaultText='Create'
				/>
			</div>
			{data?.length > 0 && (
				<table className='styled-table'>
					<thead>
						<tr>
							<th>No.</th>
							<th>Title</th>
							<th>From</th>
							<th>To</th>
							<th>Color</th>
							<th>Message</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody className='queue'>
						{data
							.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
							.map((element, index) => (
								<tr>
									<td>{index + 1}.</td>
									<td>{element.title}</td>
									<td>
										{element.from && formatDate(element.from, 'YYYY-MM-DD')}
									</td>
									<td>{element.to && formatDate(element.to, 'YYYY-MM-DD')}</td>
									<td>{element.color}</td>
									<td style={{ maxWidth: '400px' }}>{element.message}</td>
									<td>
										<Icon
											name='edit'
											className='animation-scale'
											onClick={() => {
												setEdit(element);
												setMode(() => MODE.EDIT);
											}}
											style={{ cursor: 'pointer' }}
										/>
									</td>
								</tr>
							))}
					</tbody>
				</table>
			)}
			{mode && (
				<BlackboardAction
					data={edit || {}}
					mode={mode}
					reload={handleLoadData}
					setShow={setMode}
					usersOptions={usersOptions}
				/>
			)}
		</Wrapper>
	);
};

export default BlackboardList;
